import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminUsers.css';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [tools, setTools] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const token = localStorage.getItem('adminToken');

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    } catch (err) {
      console.error('Failed to fetch users:', err);
    }
  };

  const fetchTools = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/tools`);
      setTools(res.data);
    } catch (err) {
      console.error('Failed to fetch tools:', err);
    }
  };

  const getToolNames = (likedToolIds) => {
    return tools
      .filter((tool) => likedToolIds.includes(tool._id))
      .map((tool) => tool.name)
      .join(', ');
  };

  const deleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/users/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsers();
    } catch (err) {
      console.error('Failed to delete user:', err);
    }
  };

  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    fetchUsers();
    fetchTools();
  }, []);

  return (
    <div className="user-page">
      <h2> Registered Users</h2>
      <div className="mobile-warning">
        For the best experience and all features, please use a PC or laptop
      </div>
      <input
        type="text"
        placeholder="🔍 Search by name or email"
        className="user-search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <table className="user-table">
        <thead>
          <tr>
            <th className="subs-hide">S.No.</th>
            <th>Name</th>
            <th>Email</th>
            <th className="subs-hide">Liked Tools</th>
            <th className="subs-hide">Joined At</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user, idx) => (
            <tr key={user._id}>
              <td className="subs-hide">{idx + 1}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td className="subs-hide">{getToolNames(user.likedTools)}</td>
              <td className="subs-hide">{new Date(user.createdAt).toLocaleString()}</td>
              <td>
                <button className="delete-user-btn" onClick={() => deleteUser(user._id)}>
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUsers;
